<template>
  <nav
    v-if="pagesLength > 1"
    class="paginate"
  >
    <ul class="list paginate_wrap">
      <!-- Кнопка "Предыдущая" -->
      <li class="paginate-item">
        <button
          :disabled="currentPage === 1"
          aria-label="Previous"
          class="btn-primary-stroke p0 wh40"
          @click="changePage(currentPage - 1)"
        >
          <i class="i-arrow rot_r" />
        </button>
      </li>

      <!-- Первая страница -->
      <li class="paginate-item">
        <button
          :class="{ 'btn-primary': currentPage !== 1, 'active': currentPage === 1 }"
          @click="changePage(1)"
        >
          1
        </button>
      </li>

      <!-- Точки, если текущая страница больше 3 -->
      <li
        v-if="currentPage > 3"
        class="paginate-item dots"
      >
        ...
      </li>

      <!-- Показать предыдущую страницу, если она не первая -->
      <li
        v-if="currentPage > 2"
        class="paginate-item"
      >
        <button
          class="btn-primary"
          @click="changePage(currentPage - 1)"
        >
          {{ currentPage - 1 }}
        </button>
      </li>

      <!-- Текущая страница, если она не первая и не последняя -->
      <li
        v-if="currentPage !== 1 && currentPage !== pagesLength"
        class="paginate-item"
      >
        <button
          class="btn-primary active"
        >
          {{ currentPage }}
        </button>
      </li>

      <!-- Показать следующую страницу, если она не последняя -->
      <li
        v-if="currentPage < pagesLength - 1"
        class="paginate-item"
      >
        <button
          class="btn-primary"
          @click="changePage(currentPage + 1)"
        >
          {{ currentPage + 1 }}
        </button>
      </li>

      <!-- Точки, если до последней страницы больше одной страницы -->
      <li
        v-if="currentPage < pagesLength - 2"
        class="paginate-item dots"
      >
        ...
      </li>

      <!-- Последняя страница -->
      <li class="paginate-item">
        <button
          :class="{ 'btn-primary': currentPage !== pagesLength, 'active': currentPage === pagesLength }"
          @click="changePage(pagesLength)"
        >
          {{ pagesLength }}
        </button>
      </li>

      <!-- Кнопка "Следующая" -->
      <li class="paginate-item">
        <button
          :disabled="currentPage === pagesLength"
          aria-label="Next"
          class="btn-primary-stroke p0 wh40"
          @click="changePage(currentPage + 1)"
        >
          <i class="i-arrow rot_l" />
        </button>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
const props = defineProps<{
  pagesLength: number
  useQuery?: boolean
}>();
const emit = defineEmits<{
  (e: 'onPageChange', page: number): void
}>();
const page = defineModel<number>();
const route = useRoute();
const router = useRouter();

const currentPage = computed(() => {
  if (props.useQuery) {
    return Number(route.query.page) || 1;
  }
  return page.value || 1;
});

function changePage(newPage: number) {
  if (newPage >= 1 && newPage <= props.pagesLength) {
    if (props.useQuery) {
      router.push({ query: { ...route.query, page: newPage } });
    } else {
      page.value = newPage;
      emit('onPageChange', newPage);
    }
  }
}
</script>

<style lang="scss" scoped>
.paginate {
  padding: 3.2rem 0 0;

  &_wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.8rem;
  }

  button {
    width: 4rem;
    height: 4rem;
    padding: 0;

    &.active {
      background: var(--accent-secondary);
      color: var(--accent-on-accent-secondary);
    }
  }
}
</style>
